import { useEffect } from "react";
import { Flex, Spinner, Text } from "@chakra-ui/react";
import {
  primaryAlt,
  textPrimary,
  textSecondary,
} from "../../../../../utils/colors";
import { useTranslation } from "react-i18next";
// import { getPatientPortalTreatmentPlansAction } from "../../../../../actions/patientActions";
import { publicGetPortalPatientTreatmentPlansAction } from "../../../../../actions/publicActions";
import { useDispatch, useSelector } from "react-redux";
import PatientPortalOnePlan from "./PatientPortalOnePlan";
import PatientPortalMultiplePlans from "./PatientPortalMultiplePlans";
import PatientPortalNoPlans from "./PatientPortalNoPlans";

const PatientPortalVerified = ({
  slug,
  patientId,
  clinicName,
  token,
  patientPortalPublicDetails,
}) => {
  const { t } = useTranslation();

  // REDUX
  const dispatch = useDispatch();

  const publicPortalGetTreatmentPlans = useSelector(
    (state) => state.publicPortalGetTreatmentPlans
  );
  const {
    loading: loadingTreatmentPlans,
    error: errorTreatmentPlans,
    treatmentPlans,
  } = publicPortalGetTreatmentPlans;

  const publicPortalTreatmentPlanApprove = useSelector(
    (state) => state.publicPortalTreatmentPlanApprove
  );
  const {
    loading: loadingApprove,
    error: errorApprove,
    success: successApprove,
  } = publicPortalTreatmentPlanApprove;

  // USE EFFECT
  useEffect(() => {
    if (token) {
      dispatch(
        publicGetPortalPatientTreatmentPlansAction(slug, patientId, token)
      );
    }
  }, [slug, patientId, token, successApprove]);

  // LOG
  // console.log("treatmentPlans: ", treatmentPlans);
  // console.log("patientPortalPublicDetails: ", patientPortalPublicDetails);
  // console.log("patientId: ", patientId);

  return (
    <>
      {!loadingTreatmentPlans ? (
        <>
          {treatmentPlans && treatmentPlans.length > 0 ? (
            <Flex
              w="100%"
              align="center"
              justify="center"
              direction="column"
              p={["2rem 0rem 3rem", "3rem 0 3rem"]}
            >
              {treatmentPlans && treatmentPlans.length === 1 ? (
                <>
                  <Flex
                    w="100%"
                    align="center"
                    justify="center"
                    direction="column"
                    p={["0 1.5rem 0rem", "0 0 0rem"]}
                  >
                    {/* <Text
                        fontSize="1.25rem"
                        color={textPrimary}
                        fontWeight="500"
                        textAlign="center"
                      >
                        {clinicName && clinicName}
                      </Text> */}
                    <Text
                      fontSize={["1.5rem", "2rem"]}
                      color={textPrimary}
                      fontWeight="500"
                      m="0.25rem 0 0.5rem"
                      textAlign="center"
                    >
                      {t("patient.onePlanTitle")}
                    </Text>

                    <Text
                      fontSize="md"
                      color={textSecondary}
                      fontWeight="500"
                      textAlign="center"
                      maxW={["100%", "800px"]}
                      p={["0 1.5rem", "0 3rem"]}
                      m="0 auto"
                      lineHeight="1.5"
                    >
                      {t("patient.onePlanSubtitle")}
                    </Text>
                  </Flex>
                  <PatientPortalOnePlan
                    treatmentPlans={treatmentPlans}
                    clinicName={clinicName}
                    patientPortalPublicDetails={patientPortalPublicDetails}
                    token={token}
                  />
                </>
              ) : (
                <PatientPortalMultiplePlans
                  treatmentPlans={treatmentPlans}
                  clinicName={clinicName}
                  patientPortalPublicDetails={patientPortalPublicDetails}
                  token={token}
                />
              )}
            </Flex>
          ) : (
            <PatientPortalNoPlans clinicName={clinicName} />
          )}
        </>
      ) : (
        <Flex w="100%" align="center" justify="center" minH="300px">
          <Spinner size="lg" color={primaryAlt} m="0 auto" />
        </Flex>
      )}
    </>
  );
};

export default PatientPortalVerified;
